import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { CityService } from '../../../../../services/city.service';
import { CountryService } from '../../../../../services/country.service';
import { Validation } from '../../../error/error-messages/validator-messages';
import Swal from 'sweetalert2';
import { City } from '../../../../../models/city.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.scss']
})
export class CityComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton2') closebutton2;

  // @ts-ignore
  city: ICity[] = [];
  // @ts-ignore
  cities: ICity[] = [];
  // @ts-ignore
  currentCity: ICity = [];
  // @ts-ignore
  country: ICountry[] = [];

  search: any;
  page = 1;
  perPage = 10;
  /*
  end for all page
   */
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;

  constructor(private fb: FormBuilder, private cityService: CityService,
              private countryService: CountryService, private router :Router) { }

  ngOnInit(): void {
    this.loadCity();
    this.loadCountry();
  }

  get f() { return this.cityForm.controls; }
  get f1() { return this.editCityForm.controls; }

  cityForm = this.fb.group({
    iso: new FormControl('', [ Validation.stringValidator("L\'iso",2,3),]),
    name: new FormControl('', [ Validation.cityValidator("La ville",3,10),]),
    country: new FormControl('', [ Validation.requiredValidator("Le pays")]),
  });

  editCityForm = this.fb.group({
    iso: new FormControl('', [ Validation.stringValidator("L\'iso",2,3)]),
    name: new FormControl('', [ Validation.cityValidator("La ville",3,10)]),
    country: new FormControl('', [ Validators.required]),
  });

  loadCity = () => {
    this.cityService.getAllCities()
      .subscribe(data => {
        this.city = data;
      }, (err) => {
        //console.log('-----> err', err);
      });
  }

  loadCountry = () => {
    this.countryService.getCountries()
      .subscribe(data => {
        this.country = data;

      }, (err) => {
       // console.log('-----> err', err);
      });
  }

  onCityFormSubmit() {
    //console.log(this.cityForm.value);
    const city: City = this.cityForm.value;
    this.countryService.getidCountry(this.cityForm.controls['country'].value).subscribe(
      data => {
        city.country = data;
        this.cityService.saveCity(city).subscribe(rs => {
          // console.log(rs);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La ville a été ajoutée avec succés"',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadCity();
          this.reloadComponent();
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    );
  }

  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  deleteCity(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez vous vraiment supprimer cette ville ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.cityService.deleteCity(id).subscribe(
        rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La ville a été supprimée avec succés"',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadCity();
        }
      );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    });

     /*  this.cityService.deleteCity(id).subscribe(
        rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Ville supprimée avec succés"',
            showConfirmButton: false,
            timer: 1500
          });
          window.location.reload();
        }
      ); */

  }

  onEditCity(id: any) {
    this.cityService.getidCity(id).subscribe(rs => {
      this.currentCity = rs;
      this.editCityForm = this.fb.group({
        id: new FormControl(this.currentCity.id, [ ]),
        iso: new FormControl(this.currentCity.iso, [ Validation.stringValidator("L\'iso",2,3)]),
        name: new FormControl(this.currentCity.name, [ Validation.cityValidator("La ville",3,10)]),
        country: new FormControl(this.currentCity.country, [ Validators.required] ),
      });
      // @ts-ignore
      this.editCityForm.get('country').setValue(this.currentCity.country?.id);
    });
  }

  onEditCityFormSubmit() {
    //console.log(this.editCityForm.value);
    const city: City = this.editCityForm.value;
    this.countryService.getidCountry(this.editCityForm.controls['country'].value).subscribe(
      data => {
        city.country = data;
        this.cityService.updateCity(city).subscribe(rs => {
          //console.log(rs);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La ville a été modifiée avec succés"',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadCity();
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Veuillez vérifier les données',
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    );

  }

  onViewCity(id: any) {
    this.cityService.getidCity(id).subscribe(rs => {
      this.currentCity = rs;
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    //console.log(this.perPage);
  }

  searchFilter($event: KeyboardEvent) {
    //console.log(this.search);
    this.cityService.getAllCities().subscribe(data => {
        this.city = data;
        this.city = this.city.filter(value =>
           value.name?.toUpperCase().includes(this.search.toUpperCase())
          || value.iso?.toUpperCase().includes(this.search.toUpperCase())
          || value.country?.name?.toUpperCase().includes(this.search.toUpperCase())
          || value.country?.iso?.toUpperCase().includes(this.search.toUpperCase())
        );
      }, (err) => {
       // console.log('-----> err', err);
      });
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.city.sort((a, b) => a.iso > b.iso ? 1 : a.iso < b.iso ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignoe
      this.city.sort((a, b) => a.iso < b.iso ? 1 : a.iso > b.iso ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.city.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.city.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.city.sort((a, b) => a.country?.iso > b.country?.iso ? 1 : a.country?.iso < b.country?.iso ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.city.sort((a, b) => a.country?.iso < b.country?.iso ? 1 : a.country?.iso > b.country?.iso ? -1 : 0)
      this.sorted3 = false;
    }
  }

  close() {
    this.closebutton.nativeElement.click();
    this.closebutton2.nativeElement.click();
  }

  isCountryExistTrue=false;
  isCityExistTrue = false;
  cityName : any;
  cityCountryName : any;
  displayeMessageError=false;
  countryId : any;
  getIfNameExist(value: any) {
    // console.log("Id " +this.countryId)
    this.cityName = value.target.value;
    if(this.countryId!=undefined){
      this.isCountryExistTrue = false;
      this.getIfCityNameExist(this.countryId);
    }
  }


  getIfCityNameExist(value: any) {
    if (value) {
      this.countryId = value;
      this.cityService.getCitiesByCountry(value).subscribe((data :any)=>{
        this.cities = data;
        this.cities.forEach(element => {
          if (element.name?.toUpperCase() === this.cityName.toUpperCase()) {
            this.isCountryExistTrue = true;
          }
        });
        if(this.isCountryExistTrue){
          this.displayeMessageError = true;
        }else{
          this.displayeMessageError = false;
        }
        // console.log("Error Message")
        // console.log(this.displayeMessageError)
      });
    }
  }





  // getIfNameExist(value: any){
  //   let tabCity:any= this.city;
  //   this.cityName = value.target.value;
  //   // Vérifie si la valeur existe dans le tableau
  //   console.log(tabCity)
  //   if(this.cityName!=''){
  //     tabCity.forEach(element => {
  //       if(element.name?.toUpperCase().includes(this.cityName.toUpperCase())){
  //         this.cityCountryName = element?.country?.iso;
  //       }
  //     });
  //   }
  // }

  // getIfCityNameExist(value: any){
  //   let tabCountry:any= this.country;
  //   console.log(value)
  //   console.log(tabCountry)
  //   if(value!=''){
  //     tabCountry.forEach(element => {
  //       if(element.iso?.toUpperCase().includes(this.cityCountryName.toUpperCase())){
  //         this.isCountryExistTrue=true;
  //         if(this.isCityExistTrue){
  //           this.displayeMessageError = true;
  //         }else{
  //           this.displayeMessageError = false;
  //         }
  //       }
  //     });
  //   }
  // }

  isSameOne=false
  isSameTwo=false

  verifySameValue(a,b){
    if((this.cityForm.controls[a].value!='')&& this.cityForm.controls[a].value==this.cityForm.controls[b].value){
      this.isSameOne = true;
    }
    if((this.cityForm.controls[b].value!='' )&& this.cityForm.controls[b].value==this.cityForm.controls[a].value){
      this.isSameTwo = true;
    }
  }

  isoequalstocity = false;
  verifyISOAndCity(){
    if(this.cityForm.controls['name'].value != ""){
      if(this.cityForm.controls['iso'].value==this.cityForm.controls['name'].value){
        this.isoequalstocity = true;
      }else{
        this.isoequalstocity = false;
      }
    }else{
      this.isoequalstocity = false;
    }

    return this.cityForm.controls['iso'].value!=this.cityForm.controls['name'].value;
  }

  isoequalstocity1 = false;
  verifyISOAndCity1(){
    if(this.editCityForm.controls['name'].value != ""){
      if(this.editCityForm.controls['iso'].value==this.editCityForm.controls['name'].value){
        this.isoequalstocity = true;
      }else{
        this.isoequalstocity = false;
      }
    }else{
      this.isoequalstocity = false;
    }

    return this.editCityForm.controls['iso'].value!=this.editCityForm.controls['name'].value;
  }
}
